import { getAuthHeader } from "./authService";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/fichas-medicas`;
export const INSTITUCION_ID = "16020324-f0ea-4319-905c-5a30618ce9f5";

/* ===== Helpers ===== */
const toJson = (res) => res.json().catch(() => ({}));
const ensureOk = (res, data) => {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};
const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
};

export async function updateFichaMedica(id, ficha) {
  const payload = clean({
    deportista_id: ficha.deportista_id ,
    grupo_sanguineo: ficha.grupo_sanguineo,
    alergias: ficha.alergias,
    contacto_emergencia: ficha.contacto_emergencia,
    telefono_emergencia: ficha.telefono_emergencia,
    peso: ficha.peso,
    altura: ficha.altura,
    observaciones_medicas: ficha.observaciones_medicas,

    parentesco_contacto: ficha.parentesco_contacto,
    enfermedades_cronicas: ficha.enfermedades_cronicas,
    lesiones_y_cirugias: ficha.lesiones_y_cirugias,
    biceps_cm: ficha.biceps_cm,
    triceps_cm: ficha.triceps_cm,
    pecho_cm: ficha.pecho_cm,
    espalda_cm: ficha.espalda_cm,
    cintura_cm: ficha.cintura_cm,
    cadera_cm: ficha.cadera_cm,
    cuadriceps_cm: ficha.cuadriceps_cm,
    pantorrilla_cm: ficha.pantorrilla_cm,

    cedula_scan_url: ficha.cedula_scan_url,
  });
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

export async function getFichaMedica(id) {
  const res = await fetch(`${BASE_URL}/${id}`, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

export async function createFichaMedica(ficha) {
  const payload = clean({
    ...ficha,
  });
  const res = await fetch(`${BASE_URL}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}
